import React, {useEffect, useRef} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export const AnimatedBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        let width, height;
        let lines = [];
        const lineCount = 80;

        class Line {
            constructor() {
                this.reset();
            }

            reset() {
                this.x = Math.random() * width;
                this.y = Math.random() * height;
                this.length = Math.random() * 120 + 60;
                this.speed = Math.random() * 0.5 + 0.2;
                this.angle = Math.random() * Math.PI * 2;
                this.dx = Math.cos(this.angle) * this.speed;
                this.dy = Math.sin(this.angle) * this.speed;
                this.opacity = 0;
                this.fadeIn = true;
            }

            draw() {
                ctx.beginPath();
                ctx.moveTo(this.x, this.y);
                ctx.lineTo(this.x + this.dx * this.length, this.y + this.dy * this.length);
                ctx.strokeStyle = `rgba(144, 202, 249, ${this.opacity * 0.2})`;
                ctx.lineWidth = 1.5;
                ctx.stroke();
            }

            update() {
                this.x += this.dx;
                this.y += this.dy;
                if (this.fadeIn) {
                    if (this.opacity < 1) this.opacity += 0.01; else this.fadeIn = false;
                } else {
                    if (this.x < 0 || this.x > width || this.y < 0 || this.y > height) {
                        this.opacity -= 0.01;
                        if (this.opacity <= 0) this.reset();
                    }
                }
            }
        }

        const init = () => {
            const container = canvas.parentElement;
            width = container.clientWidth;
            height = container.clientHeight;
            canvas.width = width;
            canvas.height = height;
            lines = [];
            for (let i = 0; i < lineCount; i++) {
                lines.push(new Line());
            }
        };
        let animationFrameId;
        const animate = () => {
            ctx.clearRect(0, 0, width, height);
            lines.forEach(line => {
                line.update();
                line.draw();
            });
            animationFrameId = requestAnimationFrame(animate);
        };
        init();
        animate();
        window.addEventListener('resize', init);
        return () => {
            window.removeEventListener('resize', init);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <Grid item xs={false} sm={4} md={7}
              sx={{
                  position: 'relative',
                  background: 'linear-gradient(-45deg, #0a192f, #172a46, #303c55)',
                  backgroundSize: '400% 400%',
                  animation: 'gradient 15s ease infinite',
                  '@keyframes gradient': {
                      '0%': {backgroundPosition: '0% 50%'},
                      '50%': {backgroundPosition: '100% 50%'},
                      '100%': {backgroundPosition: '0% 50%'}
                  },
                  display: {xs: 'none', lg: 'flex'},
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'white',
              }}
        >
            <canvas ref={canvasRef}
                    style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0}}/>
            <Box sx={{zIndex: 1, p: 4}}>
                <Typography component="h1" variant="h3" fontWeight="bold" gutterBottom>
                    BUS Soft
                </Typography>
                <Typography variant="h6" color="rgba(255, 255, 255, 0.7)">
                    Business and ticketing management system
                </Typography>
            </Box>
        </Grid>
    );
};
